import { createActionGroup, emptyProps, props } from '@ngrx/store'

import { GiftCardDuration } from '../../models/enum/voucher-durations.enum'
import { PlanTypes } from '../../models/plan.model'
import { Order } from '../../models/order.model'
import { Coupon } from '../../models/coupon.model'

export const OrderActions = createActionGroup({
  source: 'Order',
  events: {
    'Init Order Component': props<{
      planType: PlanTypes | null
      voucherDuration: GiftCardDuration | null
      isOnlyFamily: boolean
      coupon: Coupon | null
    }>(),
    'Create Order': props<{ order: Order }>(),
    'Remove Order': emptyProps(),
    'Set Family Option': props<{ familyOption: boolean }>(),
    'Set Coupon': props<{ coupon: Coupon }>(),
    'Start Loading': emptyProps(),
    'Stop Loading': emptyProps(),
  },
})

export const OrderApiActions = createActionGroup({
  source: 'Order API',
  events: {
    'Start Payment Process With No Payment Id': emptyProps(),
    'Pay Order With No Payment Id': emptyProps(),
    'Pay Migration': props<{ defaultPaymentMethodId: string }>(),
    'Migration Paid': props<{ defaultPaymentMethodId: string }>(),
    'Pay Order With Payment Id': props<{ paymentId: string }>(),
    'Pay Subscription': props<{ paymentId: string }>(),
    'Pay Family Option': props<{ paymentId: string }>(),
    'Payment Finished': emptyProps(),
    Failed: props<{ errorMessage: string | null }>(),
    'Start Cancelling': props<{ isOnlyFamilyOption: boolean }>(),
    'Cancel Active Subscription': emptyProps(),
    'Cancel Family Option': props<{ isMigration: boolean }>(),
    'Stop Cancelling': emptyProps(),
    'Start Resuming': props<{ isFamilyOption: boolean }>(),
    'Finish Resuming': props<{ isFamilyOption: boolean }>(),
    'Resume Family Option In Migration Process': emptyProps(),
  },
})
